import {
  addMyPaymentOrder, addMyPaymentOutstandingOrder, refreshingMyPaymentInvoice,
} from '../simple-action';
import * as Helper from '../../../helper';

export default data => async (dispatch, getState) => {
  try {
    dispatch(refreshingMyPaymentInvoice(true));

    const { token } = getState().authentication;
    const { tappedProformaNo } = getState().uiMyPaymentHistory;
    const { myOutstandingOrder, myOrder } = getState();

    const response = await Helper.refreshMyPaymentInvoice(tappedProformaNo, data.id, token);

    if (myOrder[tappedProformaNo]) {
      dispatch(addMyPaymentOrder(response));
    }
    if (myOutstandingOrder[tappedProformaNo]) {
      dispatch(addMyPaymentOutstandingOrder(response));
    }
  } finally {
    dispatch(refreshingMyPaymentInvoice(false));
  }
};
